import { css } from "styled-components/macro";

export const SecondaryStyles = css(({ theme, color = "default" }) => {
  const setColor =
    color === "default" ? theme.colors.primary : theme.colors[color];

  return `color: ${setColor};
  background-color: ${theme.colors.white};
  border: 1px solid ${setColor};

  &:hover:enabled {
    color: ${theme.colors.white};
    background-color: ${setColor};
  }
`;
});
